import { FC } from 'react';
import { Outlet } from 'react-router-dom';
import { ErrorBoundary } from '../ErrorBoundary/ErrorBoundary';
import { Layout, RouteOutlet } from './AppRoutes.style';
import { TopBar } from './Components/TopBar/TopBar';

export const CleanLayout: FC = () => {
    return (
        <Layout>
            <TopBar />
            <ErrorBoundary>
                <RouteOutlet>
                    <Outlet />
                </RouteOutlet>
            </ErrorBoundary>
        </Layout>
    );
};
